import EngineeringIcon from "@mui/icons-material/Engineering";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import "./CADSection.css";
import { Link } from "react-router-dom";
import CourseEnquiryButton from "../../CAD_Home/CourseEnquiryButton";

function CADSection() {
    return (
        <section className="course-content-section " style={{
            marginTop: -25
        }}>

            <div className="content-layout ">

                <div className="content-main">

                    {/* <div className="content-label">
                        CAD & PLM AUTOMATION
                    </div> */}

                    <h3>
                        Turn CAD Skills Into
                        <span>
                            {" "}High-Value <br />
                            CAD-Automation Skills
                        </span>
                    </h3>

                    <p className="content-intro">
                        CAD Automation is a niche engineering
                        skill with strong industry demand.
                        Learn customization and automation
                        step-by-step with expert guidance.
                    </p>

                    <div className="benefits-grid">

                        <Benefit text="Earn 3–4X More – CAD Developers can earn significantly more than traditional design roles." />

                        <Benefit text="Rare Skills = High Pay – CAD Automation is a niche skill with limited experts and high demand." />

                        <Benefit text="Job Market Advantage – Less competition compared with traditional CAD Design roles." />

                        <Benefit text="Easy to Begin, High to Grow – Start with CAD Design and progress toward advanced automation." />

                        <Benefit text="We Make It Simple – Learn complex CAD Automation step-by-step with expert-guided training." />

                    </div>

                    <div className="demo-class" style={{
                        marginTop: "45px"
                    }}>
                        <CourseEnquiryButton buttonText={"Schedule a free demo class"} />

                    </div>





                </div>


                <div className="content-side">

                    <div className="side-card">

                        <div className="side-card-icon">
                            <EngineeringIcon />
                        </div>

                        <h4>
                            CAD Automation Courses
                        </h4>

                        <p>
                            Explore our specialized
                            customization and automation
                            training programs.
                        </p>

                        <div className="course-links">

                            <CourseLink
                                text="General CAD Customization"
                                to="/cad-customization-courses"
                            />

                            <CourseLink
                                text="NX Open"
                                to="/nx-open-customization-automation-training"
                            />

                            <CourseLink
                                text="CATIA CAA"
                                to="/catia-caa-customization-automation-training"
                            />

                            <CourseLink
                                text="Python CATIA"
                                to="/python-catia-automation-customization"
                            />

                            <CourseLink
                                text="Creo Toolkit"
                                to="/creo-toolkit-customization-training"
                            />

                            <CourseLink
                                text="SolidWorks API"
                                to="/solidworks-api-customization-automation-training"
                            />

                            <CourseLink
                                text="AutoCAD API"
                                to="/autocad-api-customization-automation-online-courses"
                            />

                            <CourseLink
                                text="Revit API"
                                to="/autodesk-revit-api-customization-automation-course"
                            />

                            <CourseLink
                                text="Inventor API"
                                to="/autodesk-inventor-api-customization-automation-course"
                            />

                            <CourseLink
                                text="Teamcenter PLM"
                                to="/teamcenter-plm-customization-training-itk-rac-soa-awc"
                            />

                            <CourseLink
                                text="Windchill PLM"
                                to="/ptc-windchill-plm-customization-course"
                            />

                        </div>

                    </div>

                </div>

            </div>




        </section>
    );
}


function Benefit({ text }) {

    return (
        <div className="benefit-item">

            <CheckCircleIcon />

            <span>
                {text}
            </span>

        </div>
    );
}


function CourseLink({ text, to }) {

    return (
        <Link
            to={to}
            className="course-link"
        >
            <span>
                {text}
            </span>

            <ArrowForwardIcon />
        </Link>
    );
}


export default CADSection;